
import { PageNumber, Document, Footer, Paragraph, TextRun, Table, TableRow, TableCell, ImageRun, Packer, Header, TabStopType, HeadingLevel, PageBreak, VerticalAlign, BorderStyle, WidthType } from 'docx'
import { getDownloadURL } from '@/services/aws'
import { isObject } from '@/services/validation'
import { useStreetCabinetUploadField } from '@/config'
import evImg from '../assets/image/EVlogoBlack.png'
import store from '@/store'
import i18n from '@/plugins/i18n';

let sizeOf = require('buffer-image-size')

const getFirstDocByType = ({ record, doctype }) => {
  let location = record.getLocation()

  return location.Docs[doctype] && Array.isArray(location.Docs[doctype])
    ? location.Docs[doctype][0]
    : null
}

const getImageFromAWS = async ({ Doc, doctype, record, token }) => {
  let img = Doc

  const collectionName = 'Processes'

  if (!img) {
    img = getFirstDocByType({ record, doctype })
  }

  if (!isObject(img)) {
    img = {
      id: img,
      ext: null,
    }
  }

  img.link = await getDownloadURL({
    token,
    ref: record.ref,
    uuid: record.uuid,
    casefull: record.case_ref,

    index: img.id,
    doctype,
    ext: img.ext || null,
    collectionName
  }).catch(err => console.log(err))

  if (img.link) {
    let file = await fetch(img.link.url)
    let arrayBuffer = await file.arrayBuffer()
    img.buffer = Buffer.from(arrayBuffer)

    let size = sizeOf(img.buffer)
    let sizeFactor = size.width > 600 ? 600 / size.width : 1

    img.calcSize = {
      width: size.width * sizeFactor,
      height: size.height * sizeFactor,
    }
  }

  return img
}

const setStakeholderValue = (stakeholder) => {
  const composedValue = ['Organisation', 'Firstname', 'Lastname'].map(prop => {
    const hasOrganisation = (prop === 'Organisation' && stakeholder?.[prop] && Object.keys(stakeholder).length > 1)
    if (hasOrganisation) {
      return stakeholder?.[prop] + ' | '
    }

    return stakeholder?.[prop]
  }).filter(Boolean)

  return composedValue.join(' ') || stakeholder || i18n.t('none')
}

const generatePrivateSection = async ({ record, token }) => {
  const evLogo = await fetch(evImg)
  // Label translations //
  const stakeholdersPath = store.getters['tenant/getSteps'].at(0).form.filter(field => field.path.includes('Stakeholders'))

  let casefull = record.getCaseRef()
  const stakeholders = record.Stakeholders
  let location = record.Object

  const headerTitle = record.Object.ProjectName
  const currentStep = record.flow.state.findLast(state => state.started_at)?.started_at
  const generatedAt = new Date(currentStep).toLocaleDateString('nl-NL',
    { day: 'numeric', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' }
  )

  const docTypes = {
    TopView: { label: i18n.t('processes.sidebar.topview'), views: [] },
    SideView: { label: i18n.t('processes.sidebar.sideview'), views: [] },
    InitialLocationViews: { label: i18n.t('processdoc.InitialLocationViews'), views: [] },

  }
  // Wait for all available views to be downloaded first
  let allImages = []
  Object.keys(docTypes).map(doctype => {
    record.Docs[doctype]?.map(Doc => allImages.push({ doctype, Doc }))
  })

  await Promise.all(
    allImages.map(async img => {
      const image = await getImageFromAWS({ Doc: img.Doc, doctype: img.doctype, record, token })
      docTypes[img.doctype].views.push(image)
      return image
    })
  )

  let children = [
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.projectInfo'),
          bold: true,
          size: 24,
          font: 'Avenir'

        })]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('recordList.address'),
          bold: false,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t\t${location.Address.FullAddress || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('recordList.ProjectName'),
          bold: false,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t${location.ProjectName || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('recordList.ProjectNumber'),
          bold: false,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t${location.ProjectNumber || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.ContractorMainConnection'),
          bold: false,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t${location.ContractorMainConnection || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.PropertyRights'),
          bold: false,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t${location.PropertyRights || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.contactInfo'),
          bold: true,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.firstName'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t\t\t\t${record.Stakeholders?.CustomerContact?.Firstname || i18n.t('none')}`, font: 'Avenir' })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.lastName'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t\t\t\t${record.Stakeholders?.CustomerContact?.Lastname || i18n.t('none')}`, font: 'Avenir' })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.emailAddress'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t\t\t\t${record.Stakeholders?.CustomerContact?.EmailAddress || i18n.t('none')}`, font: 'Avenir' })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.phoneNumber'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t\t\t${record.Stakeholders?.CustomerContact?.PhoneNumber || i18n.t('none')}`, font: 'Avenir' })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.numberOfChargingPointsToPlace'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t${record.ParkingAndChargePoints?.TotalChargePointsStillToBePlaced ?? i18n.t('none')}`, font: 'Avenir' })
      ]
    }),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.stakeholders'),
          bold: true,
          font: 'Avenir'
        }),
        ...(
          !stakeholders.length
            ? [
                new TextRun({
                  text: `\t\t\t\t${i18n.t('none')}`,
                  font: 'Avenir'
                })
              ]
            : []
        )
      ]
    }),
  ]

  Object.keys(stakeholders).filter(stakeholder => stakeholder !== 'Extra').forEach(stakeholder => {
    if (stakeholders[stakeholder]) {
      const value = setStakeholderValue(stakeholders[stakeholder])
      const stakeholderField = stakeholdersPath.find(field => field.path.endsWith(stakeholder))
      const label = stakeholderField ? stakeholderField.label[i18n.locale] : i18n.t(`processdoc.${stakeholder}`)

      const tab = label.length > 15 ? '\t\t\t' : label.length > 7 ? '\t\t\t\t' : '\t\t\t\t\t'

      children.push(
        new Paragraph({
          children: [
            new TextRun({
              text: label,
              bold: false,
              font: 'Avenir',
            }),
            new TextRun({
              text: `${tab}${value || i18n.t('none')}`,
              font: 'Avenir'
            })
          ],
        }),
      )
    }
  })

  if (stakeholders.Extra?.length) {
    stakeholders.Extra.forEach((stakeholder, index) => {
      const value = setStakeholderValue(stakeholder)

      children.push(
        new Paragraph({
          children: [
            new TextRun({
              text: !index ? i18n.t('other') : '',
              bold: false,
              font: 'Avenir',
              ...(!index ? { break: 1 } : {})
            }),
            new TextRun({
              text: `\t\t\t\t\t${value || i18n.t('none')}`,
              font: 'Avenir'
            })
          ],
        }),
      )
    })
  }

  children.push(
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.Assignment'),
          bold: true,
          font: 'Avenir'
        }),]
    }),
  )

  const chargingPointTypes = ['NumberOfChargingPointsReplaced', 'ReprogramNumberOfChargingPoints', 'NumberOfExistingChargePoints'];
  chargingPointTypes.forEach(type => {
    const tab = type.length < 30 ? '\t\t\t' : '\t\t'

    children.push(
      new Paragraph({
        children: [
          new TextRun({
            text: i18n.t(`processdoc.${type}`),
            bold: false,
            font: 'Avenir',
          }),
          new TextRun({
            text: `${tab}${record.ParkingAndChargePoints[type] || i18n.t('none')}`,
            font: 'Avenir'
          })
        ],
      })
    )
  })

  children.push(
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.mloea'), bold: false, font: 'Avenir' }),
        new TextRun({ text: `\t\t\t\t\t${record.Energy?.MLOEAYesNo || i18n.t('none')}`, font: 'Avenir' })
      ]
    }),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({ text: i18n.t('processdoc.implementation'), bold: true, font: 'Avenir' })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({ text: record.ParkingAndChargePoints?.ExecutionRemarks || i18n.t('none'), font: 'Avenir' })
      ]
    }),
  )

  children.push(
    new Paragraph({
      children: [
        new PageBreak(),
      ],
    }),
  )

  Object.keys(docTypes).forEach(doctype => {
    if (docTypes[doctype].views.length) {
      docTypes[doctype].views.forEach(doc => {
        children.push(
          new Paragraph(''),
          new Paragraph({
            children: [
              new TextRun({
                text: docTypes[doctype].label,
                bold: true,
                size: 20,
                font: 'Avenir',
              }),
              new TextRun({ break: 2 }),
              new ImageRun({
                data: doc.buffer,
                transformation: {
                  width: 450,
                  height: 300,
                },
              }),
            ],
          }),
          new Paragraph(''),
        )
      })
    }
  })
  /**
   * DOC MAIN Spec
   */
  const borders = {
    top: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    bottom: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    left: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    right: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
  };

  const docSpec = {
    sections: [
      {
        headers: {
          default: new Header({
            children: [

              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.assignmentDoc')} - ${headerTitle}`,
                    font: 'Avenir',
                    size: 36,
                  })],
                heading: HeadingLevel.TITLE,
              }),
              new Paragraph(''),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.reference')}: ${casefull}`,
                    bold: true,
                    font: 'Avenir',
                    color: '000000'
                  })
                ],
                heading: HeadingLevel.HEADING_2,

              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.generatedAt')}: ${generatedAt}`,
                    font: 'Avenir',
                    color: '000000'

                  })
                ],
                heading: HeadingLevel.HEADING_4
              }),
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Table({
                width: {
                  size: '100%',
                  type: WidthType.PERCENTAGE
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        width: {
                          size: '15%',
                          type: WidthType.PERCENTAGE
                        },
                        borders,
                        children: [
                          new Paragraph({
                            children: [
                              new TextRun({
                                children: [PageNumber.CURRENT],
                                font: 'Avenir'
                              }),
                              new TextRun({
                                children: [' / ', PageNumber.TOTAL_PAGES],
                                font: 'Avenir'
                              }),
                            ]
                          })
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        width: {
                          size: '65%',
                          type: WidthType.PERCENTAGE
                        },
                        borders,
                        children: []
                      }),
                      new TableCell({
                        width: {
                          size: '20%',
                          type: WidthType.PERCENTAGE
                        },
                        verticalAlign: VerticalAlign.TOP,
                        borders,
                        children: [
                          new Paragraph({
                            children: [
                              new ImageRun({
                                data: await evLogo.blob(),
                                transformation: {
                                  width: 130,
                                  height: 40,
                                }
                              })
                            ],
                          })
                        ]
                      })
                    ]
                  })
                ]
              })
            ]
          })
        },
        children,
      },
    ],
  }

  return docSpec
}

const generateSection = async ({ record, connectedRequests, token }) => {
  const asset = store.getters['processes/getSelectedAsset']
  const isRealisationProcess = record.processType.value === 'realisation'
  const municipalityOptions = store.getters['tenant/getAllMunicipalityOptions']
  const processType = isRealisationProcess
    ? record.getCategoryLabel()
    : i18n.t(`processes.sidebar.process_types.${record.processType.value}`)
  const municipality = municipalityOptions
    .find(mun => mun.value === record.MunicipalityCode)?.text

  const contractor = store.getters['tenant/getContractorByUuid']({ uuid: record.CurrentLocation.Contractor })
  const cpo = store.getters['tenant/getCpos'].find(cpo => cpo.value === record.CurrentLocation.ChargePointOperator)?.text
  const gridOperator = store.getters['tenant/getGridOperators'].find(go => go.value === record.CurrentLocation.GridOperator)?.text

  const relatedRequests = connectedRequests.filter(Boolean)
  const evLogo = await fetch(evImg)

  let casefull = record.getCaseRef()
  let location = record.getLocation()
  let coordinates = i18n.t('status_labels.unknown')

  const headerTitle = `${location.getStreetAndCity()}`
  const numberOfChargingStations = isRealisationProcess
    ? location.ParkingSpots.NumberOfChargingStations
    : asset.numberOfChargingStations

  const numberOfParkingSpots = isRealisationProcess
    ? location.ParkingSpots.NumberOfParkingSpots
    : asset.numberOfParkingSpots

  const procesCoordinates = location.Location

  if (procesCoordinates.Latitude) {
    coordinates = {
      lat: procesCoordinates.Latitude,
      lng: procesCoordinates.Longitude
    };
  }

  const currentStep = record.flow.state.findLast(state => state.started_at)?.started_at
  const generatedAt = new Date(currentStep).toLocaleDateString('nl-NL',
    { day: 'numeric', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' }
  )

  const docTypes = {
    TopView: { label: i18n.t('processes.sidebar.topview'), views: [] },
    SideView: { label: i18n.t('processes.sidebar.sideview'), views: [] },
    ...(useStreetCabinetUploadField
      ? { StreetCabinet: { label: i18n.t('processes.sidebar.streetCabinetView'), views: [] } }
      : {}
    )
  }
  // Wait for all available views to be downloaded first
  let allImages = []
  Object.keys(docTypes).map(doctype => {
    location.Docs[doctype]?.map(Doc => allImages.push({ doctype, Doc }))
  })

  await Promise.all(
    allImages.map(async img => {
      const image = await getImageFromAWS({ Doc: img.Doc, doctype: img.doctype, record, token })
      docTypes[img.doctype].views.push(image)
      return image
    })
  )

  let children = [
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.stakeholders'),
          bold: true,
          font: 'Avenir'

        })]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processes.stakeholders.contractor') + ':',
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t\t${contractor?.label || i18n.t('none')}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processes.stakeholders.cpo') + ':',
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t\t\t${cpo}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processes.stakeholders.gridoperator') + ':',
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t\t${gridOperator}`,
          font: 'Avenir'
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processes.stakeholders.municipality') + ':',
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t${municipality}`,
          font: 'Avenir'
        })
      ]
    }),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: i18n.t('processdoc.arrangement'),
          bold: true,
          font: 'Avenir'
        }),
      ],
    }),
  ]

  // Exclude 'Laadsituatie' for PNC tenant
  if (record.tenant !== 'park-n-charge') {
    children = children.concat([
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.chargeSituation')}: `,
            font: 'Avenir'
          }),
          new TextRun({
            text: `\t\t\t\t${location.ParkingSpots.Type === 'hub' ? i18n.t('processdoc.hub') : i18n.t('processdoc.chargingpoint')}`,
            font: 'Avenir'
          }),
        ],
        tabStops: [
          {
            type: TabStopType.LEFT,
            position: 2500,
          },
        ],
      }),
    ])
  }

  children = children.concat([
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('CurrentChargingSituationInfo.numberOfChargePoints')}`,
          font: 'Avenir'

        }),
        new TextRun({
          text: `\t\t\t\t${numberOfChargingStations}`,
          font: 'Avenir'

        }),
      ],
      tabStops: [
        {
          type: TabStopType.LEFT,
          position: 2500,
        },
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('CurrentChargingSituationInfo.numberOfParkingSpaces')}`,
          font: 'Avenir'

        }),
        new TextRun({
          text: `\t\t\t\t${numberOfParkingSpots}`,
          font: 'Avenir'

        }),
      ],
      tabStops: [
        {
          type: TabStopType.LEFT,
          position: 2500,
        },
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('RealisationProcessData.parkinglotIds')}: `,
          font: 'Avenir'
        }),
        ...((location.ParkingSpots.Identifiers.length > 0 ? location.ParkingSpots.Identifiers.map((item, index) => {
          const tabs = '\t'.repeat(index === 0 ? 5 : 6);
          return new Paragraph({
            children: [
              new TextRun({
                text: `${tabs}${item.Identifier}`,
                font: 'Avenir'
              })
            ]
          });
        }) : [new TextRun({ text: `\t\t\t\t${i18n.t('none')}`, font: 'Avenir' })])),
      ]
    })
    ,

  ])

  /**
   * FINANCIAL UNIT CONDITIONAL
   */
  if (record.tenant === 'park-n-charge') {
    children = children.concat([
      new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.finUnit')}: `,
            font: 'Avenir',
            bold: true

          }),
          new TextRun({
            text: `\t\t\t\t\t${location.FinUnit}`,
            font: 'Avenir'

          }),
        ],
      }),
    ])
  }

  children = children.concat([
    /**
     * Remarks
     */
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.explanationLocation')}: `,
          bold: true,
          font: 'Avenir'

        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: location.Remarks || i18n.t('none'),
          font: 'Avenir'
        })
      ]
    }),
  ])

  children = children.concat([
    /**
     * Remarks
     */
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.locationPreparation')}: `,
          bold: true,
          font: 'Avenir'

        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('recordList.gridOperator')}: `,
          font: 'Avenir'

        }),
        new TextRun({
          text: `\t\t\t\t${gridOperator}`,
          font: 'Avenir'

        }),
      ],
      tabStops: [
        {
          type: TabStopType.LEFT,
          position: 2500,
        },
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.activities')}: `,
          font: 'Avenir'
        }),
        ...((location.LocationPreparation.RequiresLocationPreparation.length > 0 ? location.LocationPreparation.RequiresLocationPreparation.map((item, index) => {
          const tabs = '\n' + '\t'.repeat(index === 0 ? 5 : 6);
          return new Paragraph({
            children: [
              new TextRun({ text: `${tabs}${item}`, font: 'Avenir' }),
            ],
            font: 'Avenir'
          });
        }) : [new TextRun({ text: '\t'.repeat(5) + i18n.t('none'), font: 'Avenir' })])),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.otherActivities')}: `,
          font: 'Avenir'

        }),
        new TextRun({
          text: `\t\t\t\t\t${location.LocationPreparation.OtherReason || i18n.t('none')}`,
          font: 'Avenir'
        })
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('GridConnection.gridOperatorNumber')}: `,
          font: 'Avenir'

        }),
        new TextRun({
          text: `\t\t\t\t${location.GridConnection.GridOperatorNumber || i18n.t('none')}`,
          font: 'Avenir'
        })
      ],
    }),

    new Paragraph(''),

    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.execution')} ${i18n.t('processdoc.chargingpoint').toLowerCase()}: `,
          bold: true,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t\t${record.tenant !== 'amsterdam' && location.CPOAdvice?.ChargingStationVersion ? location.CPOAdvice.ChargingStationVersion : '-'}`,
          font: 'Avenir',
        }),
      ],
    })
  ])

  if (record.tenant !== 'amsterdam') {
    children = children.concat([
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.power')}: `,
            bold: true,
            font: 'Avenir'
          }),
          new TextRun({
            text: `\t\t\t\t\t${location.CPOAdvice?.PowerType ? location.CPOAdvice.PowerType : i18n.t('none')}`,
            font: 'Avenir',
          }),
        ],
      })
    ])
  }

  children = children.concat([
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: record.tenant === 'park-n-charge' ? `${i18n.t('processdoc.implementation')}:` : i18n.t('processdoc.municipalityExecution'),
          bold: true,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t\t\t${location.CPOAdvice.AdditionalCostDescription || i18n.t('none')}`,
          font: 'Avenir'
        })
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.implementationContractor')}`,
          bold: true,
          font: 'Avenir'
        }),
        new TextRun({
          text: `\t${location.CPOAdvice.AdditionalCostDescriptionContractor || i18n.t('none')}`,
          font: 'Avenir'
        })
      ],
    }),

    new Paragraph(''),

    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.processType')}`,
          bold: true,
          font: 'Avenir',

        }),
        new TextRun({
          text: `\t\t\t\t${record.processType?.value ? '\t' : ''}${processType || i18n.t('none')}`,
          font: 'Avenir'
        }),
      ]
    }),

    new Paragraph('')
  ])

  children.push(
    new Paragraph({
      children: [
        new PageBreak(),
      ],
    }),
  )

  children = children.concat([
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.location')}`,
          bold: true,
          font: 'Avenir'

        }),
      ],
    }),
    new Paragraph(''),
    // new Paragraph({
    //   children: [
    //     new TextRun({
    //       text: `${i18n.t('recordList.address')}: `,
    //       font: 'Avenir',

    //     }),
    //     new TextRun({
    //       text: `\t\t\t\t\t${location?.getAddress()}`,
    //       font: 'Avenir',

    //     }),
    //   ],

    // }),
    new Paragraph({
      children: [
        new TextRun({
          text: `${i18n.t('processdoc.coordinates')}: `,
          font: 'Avenir',
        }),
        new TextRun({
          text: `\t\t\t\t${coordinates.lat}, ${coordinates.lng}`,
          font: 'Avenir'
        }),
      ]
    }),
  ])

  Object.keys(docTypes).forEach(doctype => {
    if (docTypes[doctype].views.length) {
      docTypes[doctype].views.forEach(doc => {
        children.push(
          new Paragraph(''),
          new Paragraph({
            children: [
              new TextRun({
                text: docTypes[doctype].label,
                bold: true,
                size: 20,
                font: 'Avenir',
              }),
              new TextRun({ break: 2 }),
              new ImageRun({
                data: doc.buffer,
                transformation: {
                  width: 450,
                  height: 300,
                },
              }),
            ],
          }),
          new Paragraph(''),
        )
      })
    } else if (docTypes[doctype].label.toLowerCase() !== i18n.t('processes.sidebar.streetCabinetView') || !useStreetCabinetUploadField) {
      children.push(
        new Paragraph(''),
        new Paragraph({
          children: [
            new TextRun({
              text: `${i18n.t('thereIsNo')} ${docTypes[doctype].label.toLowerCase()} ${i18n.t('available')}`,
              font: 'Avenir'
            }),
          ],
        }),
      )
    }
  })
  /**
   * DOC MAIN Spec
   */
  const borders = {
    top: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    bottom: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    left: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
    right: {
      style: BorderStyle.NONE,
      size: 0,
      color: 'FF0000',
    },
  };

  const docSpec = {
    sections: [
      {
        headers: {
          default: new Header({
            children: [

              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.startDoc')} - ${headerTitle}`,
                    font: 'Avenir',
                  })],
                heading: HeadingLevel.TITLE,
              }),
              new Paragraph(''),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.reference')}: ${casefull}`,
                    bold: true,
                    font: 'Avenir',
                    color: '000000'
                  })
                ],
                heading: HeadingLevel.HEADING_2,

              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `${i18n.t('processdoc.generatedAt')}: ${generatedAt}`,
                    font: 'Avenir',
                    color: '000000'

                  })
                ],
                heading: HeadingLevel.HEADING_4
              }),
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Table({
                width: {
                  size: '100%',
                  type: WidthType.PERCENTAGE
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        width: {
                          size: '15%',
                          type: WidthType.PERCENTAGE
                        },
                        borders,
                        children: [
                          new Paragraph({
                            children: [
                              new TextRun({
                                children: [PageNumber.CURRENT],
                                font: 'Avenir'
                              }),
                              new TextRun({
                                children: [' / ', PageNumber.TOTAL_PAGES],
                                font: 'Avenir'
                              }),
                            ]
                          })
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        width: {
                          size: '65%',
                          type: WidthType.PERCENTAGE
                        },
                        borders,
                        children: []
                      }),
                      new TableCell({
                        width: {
                          size: '20%',
                          type: WidthType.PERCENTAGE
                        },
                        verticalAlign: VerticalAlign.TOP,
                        borders,
                        children: [
                          new Paragraph({
                            children: [
                              new ImageRun({
                                data: await evLogo.blob(),
                                transformation: {
                                  width: 130,
                                  height: 40,
                                }
                              })
                            ],
                          })
                        ]
                      })
                    ]
                  })
                ]
              })
            ]
          })
        },
        children,
      },
    ],
  }

  if (relatedRequests.length !== 0) {
    docSpec.sections[0].children.push(
      new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.connectedRequests')}`,
            bold: true,
            font: 'Avenir'

          }),
        ],
      }),
    )
    docSpec.sections[0].children.push(
      new Paragraph(''),
    )
  }

  relatedRequests.forEach(request => {
    docSpec.sections[0].children.push(
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.reference')}: ${request.case_ref}`,
            font: 'Avenir',
          })
        ],
        bullet: {
          level: 0
        }
      }),
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('recordList.address')}: ${request.summary.address}`,
            font: 'Avenir'
          })
        ],
        bullet: {
          level: 1,
        },
      }),
      new Paragraph({
        children: [
          new TextRun({
            text: `${i18n.t('processdoc.requestedAt')}: ${request.summary.processed_at_short.date} ${i18n.t('processdoc.at')} ${request.summary.processed_at_short.time}`,
            font: 'Avenir'
          })
        ],
        bullet: {
          level: 1,
        },
      }),
      new Paragraph('')
    )
  })
  return docSpec
}

export const generateDoc = async ({ record, connectedRequests, token }) => {
  let realisationSection = { sections: [] };
  const isPrivateProcess = record.processType?.value === 'private'

  const processSection = isPrivateProcess
    ? await generatePrivateSection({ record, connectedRequests, token }).catch(err => console.log(err))
    : await generateSection({ record, connectedRequests, token }).catch(err => console.log(err))

  realisationSection.sections = [...processSection.sections]
  const document = new Document(realisationSection)

  return await Packer.toBlob(document)
}
